import React, { Suspense } from 'react';
import { useSelector } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { useInitLocales } from './locales';
import { selectLoader } from './core/store/loader';
import { selectDarkMode, selectShowCookieBanner } from './core/store/app';
import { useInitAnalytics, useSetTokens, useInitReviewPurchaseTracking } from './core/hooks';
import { PRODUCT_NAME, GOOGLE_SIGNUP_CLIENT_ID } from './core/constants';
import { Router } from './core/router';
import { GlobalThemeProvider, FallBack, Loader } from '@applyft-web/ui-components';
import { Alert } from './components';
import { GlobalStyles } from './core/theme';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { fixEncodedUrl } from '@applyft-web/utils';
import { sendAnalyticsEvents } from './analytics';
import { darkTheme } from './core/theme/darkTheme';

fixEncodedUrl(sendAnalyticsEvents);

const App = () => {
  const { isRtl, ready } = useInitLocales();
  const { show, message } = useSelector(selectLoader);
  const darkMode = useSelector(selectDarkMode);
  const showCookieBanner = useSelector(selectShowCookieBanner);

  useInitAnalytics();
  useSetTokens();
  useInitReviewPurchaseTracking();

  if (!ready) return <Loader show={true} />;

  return (
    <GoogleOAuthProvider clientId={GOOGLE_SIGNUP_CLIENT_ID}>
      <GlobalThemeProvider
        projectTheme={PRODUCT_NAME}
        isRtl={isRtl}
        enableRTL
        customTheme={darkMode ? darkTheme : undefined}
      >
        <GlobalStyles $showCookieBanner={showCookieBanner} />
        <Suspense fallback={<FallBack />}>
          <BrowserRouter
            future={{
              v7_startTransition: true,
              v7_relativeSplatPath: true,
            }}
          >
            <Router />
          </BrowserRouter>
          <Alert />
          <Loader show={show} message={message} />
        </Suspense>
      </GlobalThemeProvider>
    </GoogleOAuthProvider>
  );
};

export default App;
